// tslint:disable
export const dicoAA = {
    id: "1",
    cover: {
        image: "autonomie",
        title: "Assurance Autonomie",
        target: "Particuliers âgés de 18 ans à 74 ans inclus.",
        topic: "Un contrat permettant d’anticiper la perte d’autonomie.",
        tag: "Dépendance",
        age: "18 / 74 ans",
    },
    conditions: [
        "D’être âgée d’au moins 18 ans et de moins de 75 ans.",
        "D’être affiliée à un régime français ou monégasque de Sécurité sociale.",
        "L’assuré ne peut souscrire qu’une seule adhésion au titre de son contrat.",
    ],
    plus: [
        { icon: "calcul", text: "20 % de réduction sur la cotisation du conjoint." },
        { icon: "medical", text: "Une sélection médicale simplifiée unique sur le marché." },
        { icon: "shield", text: "Une couverture immédiate en cas d’accident." },
        {
            icon: "propal",
            text: "Pas de franchise pour le versement des rentes après reconnaissance de la perte d’autonomie.",
        },
        {
            icon: "chart",
            text: "Des options pour renforcer sa protection dès la perte d’autonomie partielle (rente et / ou capital).",
        },
    ],

    /* DOCUMENTS ANNEXES */

    docs: {
        adhesion: [
            {
                label: "Déclaration d’Etat de Santé",
                url: require("./documents/adhesion/declaration_de_sante.pdf"),
                required: true,
            },
            {
                label: "Fiches conseils dépendance",
                url: require("./documents/adhesion/fiches_conseils_dependance.pdf"),
                required: false,
            },
            {
                label: "Guide pratique dépendance",
                url: require("./documents/adhesion/guide_pratique_dependance.pdf"),
                required: false,
            },
            {
                label: "Notice d'information",
                url: require("./documents/adhesion/notice_information_assurance_autonomie.pdf"),
                required: true,
            },
            {
                label: "Garanties d’assistance",
                url: require("./documents/adhesion/garanties_assistance.pdf"),
                required: false,
            },
        ],
        proposition: [],
        common: [
            {
                label: "Fiche IPID",
                url: require("./documents/common/fiche_IPID_assurance_autonomie.pdf"),
                required: true,
            },
            {
                label: "Plaquette commerciale",
                url: require("./documents/common/plaquette_commerciale_assurance_autonomie.pdf"),
                required: false,
            },
            {
                label: "Dossier d’Entrée en Relation (DER)",
                url: require("../common/documents/DER_Prévoyance_Individuelle_Dynamique.pdf"),
                required: true,
            },
        ],
    },

    /********************/

    summary: {
        image: "auto",
        paragraphs: [
            {
                headline: "Une garantie obligatoire perte d’autonomie totale",
                text: "Versement d’une rente mensuelle viagère comprise entre 300 € et 4 000 € en cas de perte d’autonomie totale.",
            },
            {
                headline: "Des garanties optionnelles",
                text: "<ul><li>Une garantie optionnelle perte d’autonomie partielle : versement d’une rente mensuelle correspondant à 50 % du montant de la rente perte d’autonomie totale.</li><li>Une garantie optionnelle capital aménagement : versement d’un capital forfaitaire dès la reconnaissance de la perte d’autonomie de 2 500 € - 5 000 € - 10 000 €, aucun justificatif d’utilisation ne sera demandé.</li><li>Une assistance spécifique et innovante : un dispositif d’urgence (prise en charge de frais jusqu’à 250 €), recherche d’hébergements temporaires, accompagnement aux démarches administratives, formation pratique à domicile…</li></ul>",
            },
        ],
    },
    details: {
        paragraphs: [
            {
                headline: "Délai de carence",
                text: "<ul><li>Aucun délai de carence en cas d’accident,</li><li>1 an en cas de maladie somatique,</li><li>3 ans en cas de maladie d’Alzheimer, maladies apparentées ou pathologie psychiatrique ou neurologique.</li></ul>",
            },
            {
                headline: "Les cotisations",
                text: "<ul><li>Le montant de la cotisation est fixé en fonction de l’âge de l’adhérent à la date d’effet de l’adhésion et du montant des garanties retenues,</li><li>La cotisation est viagère, payable d’avance par mois ou par trimestre.</li></ul>",
            },
            {
                headline: "Franchises",
                text: "<ul><li>Immédiat pour le versement des rentes.</li><li>90 jours pour le versement du capital.</li></ul>",
            },
            {
                headline: "Sélection médicale",
                text: "Une déclaration d’état de santé (DES) simplifiée :</br><ul><li>Une seule question pour une souscription sans la garantie perte d’autonomie partielle,</li><li>Deux questions complémentaires pour une souscription incluant l’option garantie perte d’autonomie partielle. </li></ul>Si l’assuré répond positivement à au moins une affirmation figurant sur la DES, un questionnaire médical (au verso) doit être complété par l’assuré.",
            },
            {
                headline: "Assistance téléphonique",
                text: "Le service « Allo info » qui aide l’assuré à la recherche d’intervenants professionnels, soutien psychologique, des bilans et conseils, la recherche de maison d’accueil…",
            },
        ],
        mentions: [],
    },
    benchmark: {
        title: "Assurance Autonomie",
        head: [
            { headline: "" },
            { headline: "ag2r La Mondiale", subheading: "Assurance Autonomie" },
            { headline: "APRIL", subheading: "Serenassur Rente" },
            { headline: "BANQUE POSTALE", subheading: "Assurance Autonomie" },
            { headline: "CREDIT AGRICOLE", subheading: "Vers l'autonomie" },
        ],
        body: [
            {
                cells: [
                    "Franchise",
                    "Rente : 0 j<br>Capital : 90 j (absolue)",
                    "Rente : 90 j (absolue)<br>Capital : 0 j",
                    "Rente : 90 j (relative)<br>Capital : 0 j",
                    "Rente : 90 j (absolue)<br>Capital : 0 j",
                ],
            },
            {
                cells: [
                    "Formalités médicales",
                    "QMS (1 seule Q.)<br>QM (si QMS positif)",
                    "QMS (&#60; 15 Q.)<br> QM &#62; 15 Q. (à compléter par le médecin traitant)",
                    "Formalité simplifiée<br>QM (si positif au FS ou si +68 ans)",
                    "Question médical (15 Q.)",
                ],
            },
            {
                highlight: true,
                cells: ["Tarifs mensuels (60 ans) pour une rente à 500 €", "47.52 €", "41.02 €", "59.77 €", "55.92 €"],
            },
            {
                highlight: true,
                cells: ["Tarifs mensuels (70 ans) pour une rente à 500 €", "77.52 €", "65.14 €", "90.86 €", "89.12 €"],
            },
        ],
    },
};



// WEBPACK FOOTER //
// ./src/data/products/aa/dico.ts